import { UserConsentDto } from '@/api/generated';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import CollapsibleConsent from '@/views/process/components/personalDataForm/CollapsibleConsent.tsx';
import React from 'react';

type Props = {
  consents: UserConsentDto[];
  onConsentsChange: (consent: UserConsentDto) => () => void;
  showConsentWarning?: boolean;
};

export const PersonalDataFormConsents: React.FC<Props> = props => {
  const { consents, onConsentsChange, showConsentWarning } = props;
  const { t } = useTranslationWithPrefix('consents');

  return (
    <>
      <CollapsibleConsent
        checked={consents.includes(UserConsentDto.AdditionalPersonalDataProcessingConsentOrange)}
        content={t('additionalPersonalDataProcessingConsentOrange')}
        name="consents.[0]"
        onChange={onConsentsChange(UserConsentDto.AdditionalPersonalDataProcessingConsentOrange)}
        showWarning
        warningVisible={showConsentWarning}
      />
      <CollapsibleConsent
        checked={consents.includes(UserConsentDto.FutureRecruitmentDataProcessingConsentOrange)}
        content={t('futureRecruitmentDataProcessingConsentOrange')}
        name={UserConsentDto.FutureRecruitmentDataProcessingConsentOrange}
        onChange={onConsentsChange(UserConsentDto.FutureRecruitmentDataProcessingConsentOrange)}
      />
    </>
  );
};
